import SupportListWrapper from 'core/page/SupportListWrapper'
import { listConversionFailedEntities, listConversionStatus } from '../state/actions'
import { TooltipButton } from '@cbgms/components/form/TooltipButton'
import SearchIcon from '@mui/icons-material/Search'
import { Dialog, DialogTitleWithCloseButton } from '@carsys/ui'
import { useEffect, useRef, useState } from 'react'
import { query } from '@cbgms/components/list/query'
import { RefreshDataFunc } from '@cbgms/components/grid/Knock/KnockDataLoader'
import { useTranslation } from 'react-i18next'

// Translation keys:
//
// t('global.add_css-conversion-status'))
// t('ColumnSettingsDialog.Entities.Conversion')
// t('entities.Conversion.CSSShopID')
// t('entities.Conversion.CSSTimestamp')
// t('entities.Conversion.GMSShopID')
// t('entities.Conversion.Status')
// t('entities.Conversion.StartedAt')
// t('entities.Conversion.StoppedAt')
// t('entities.Conversion.StatusRemark')
//
// t('ColumnSettingsDialog.Entities.FailedEntity')
// t('entities.FailedEntity.EntityType')
// t('entities.FailedEntity.Error')
//
// t('Enum.EnumConversionStatus_in_progress')
// t('Enum.EnumConversionStatus_failed')
// t('Enum.EnumConversionStatus_success')
// t('Enum.EnumConversionStatus_cancelled')

const ConversionList = () => {
  const reloadListRef = useRef<RefreshDataFunc>()
  const [failedEntitiesDialogConversionUUID, setFailedEntitiesDialogConversionUUID] = useState<string | null>(null)

  useEffect(() => {
    const id = setInterval(() => {
      reloadListRef.current?.()
    }, 3_000)
    return () => clearTimeout(id)
  })

  return (
    <>
      <SupportListWrapper
        scope='css-conversion-status'
        type='list'
        loadAction={listConversionStatus}
        translationKey='css-conversion-status'
        actions={row =>
          (row.data as any).Conversion.Status === 'failed' ? (
            <TooltipButton title='Details' icon onClick={() => setFailedEntitiesDialogConversionUUID((row.data as any).Conversion.UUID)}>
              <SearchIcon />
            </TooltipButton>
          ) : null
        }
        onDataLoaderInitialized={reloadList => {
          reloadListRef.current = reloadList
        }}
      />

      {failedEntitiesDialogConversionUUID && (
        <ConversionFailedEntitiesDialog
          uuid={failedEntitiesDialogConversionUUID}
          onClose={() => setFailedEntitiesDialogConversionUUID(null)}
        />
      )}
    </>
  )
}

interface ConversionFailedEntitiesDialogProps {
  uuid: string
  onClose: () => void
}

const ConversionFailedEntitiesDialog = ({ uuid, onClose }: ConversionFailedEntitiesDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open
      onClose={onClose}
      enableBackdropClick
      fullWidth
      maxWidth='lg'
      sx={{ zIndex: 1200 }} // show the grid settings in front of dialog... I'm sorry :( (semantic dialog zIndex is 1300)
    >
      <DialogTitleWithCloseButton onClose={onClose}>{t('conversion.failed_entities_title')}</DialogTitleWithCloseButton>
      <SupportListWrapper
        scope='css-conversion-failed-entities'
        type='list'
        loadAction={params =>
          listConversionFailedEntities({
            ...params,
            search: query<any>()
              .withQueryStringNoValidation(params.search)
              .and()
              .equals('FailedEntity.CSSConversionStatusUUID', uuid)
              .toString()
          })
        }
        translationKey='css-conversion-failed-entities'
      />
    </Dialog>
  )
}

export default ConversionList
